"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VPagination = void 0;
var react_1 = __importStar(require("react"));
var style_1 = require("./style");
var core_1 = require("@blueprintjs/core");
var formstate_1 = require("formstate");
var Form_1 = require("../Form");
var types_1 = require("./types");
var range = function (from, to, step) {
    if (step === void 0) { step = 1; }
    var i = from;
    var range = [];
    while (i <= to) {
        range.push(i);
        i += step;
    }
    return range;
};
var InfoPage = function (props) {
    return (react_1.default.createElement("div", { style: { margin: '0px 10px' } },
        props.currentPage && (react_1.default.createElement("span", null,
            props.pageLabel ? props.pageLabel : 'Page',
            ' ',
            react_1.default.createElement("strong", null, props.currentPage),
            ' ',
            props.ofLabel ? props.ofLabel : 'of',
            react_1.default.createElement("strong", null,
                " ",
                props.totalPages,
                " "))),
        react_1.default.createElement("span", null,
            props.totalLabel ? props.totalLabel : 'Total',
            ":",
            ' ',
            react_1.default.createElement("strong", { className: "text-secondary" }, " ".concat(props.totals)))));
};
var ItemsByPages = function (props) {
    return (react_1.default.createElement(Form_1.VSelectField, { layer: {
            inputOrientation: 'start'
        }, filterable: false, margin: '0px 10px', inline: true, label: props.label ? props.label : 'Items by pages:', minimal: true, options: props.options, id: "items-by-page", fieldState: props.fieldState, onChange: props.onChange, color: props.color ? props.color : 'black' }));
};
var VPagination = (function (_super) {
    __extends(VPagination, _super);
    function VPagination(props) {
        var _this = _super.call(this, props) || this;
        _this.getItemsByPages = function () {
            if (_this.props.itemsByPage && _this.props.itemsByPage.length > 0) {
                return _this.props.itemsByPage;
            }
            return [
                { label: '5', value: 5 },
                { label: '10', value: 10 },
                { label: '20', value: 20 }
            ];
        };
        _this.getPageNeighbours = function () {
            var _a = _this.props.pageNeighbours, pageNeighbours = _a === void 0 ? 0 : _a;
            return Math.max(0, Math.min(pageNeighbours, 2));
        };
        _this.getTotalPages = function () {
            var _a = _this.props, _b = _a.totalRecords, totalRecords = _b === void 0 ? null : _b, _c = _a.pageLimit, pageLimit = _c === void 0 ? 30 : _c;
            return Math.ceil(totalRecords / pageLimit);
        };
        _this.getTotalsRecord = function () {
            var _a = _this.props.totalRecords, totalRecords = _a === void 0 ? 0 : _a;
            return totalRecords;
        };
        _this.getPageLimit = function () {
            var _a = _this.props.pageLimit, pageLimit = _a === void 0 ? 10 : _a;
            return pageLimit;
        };
        _this.gotoPage = function (page) {
            var _a = _this.props.onPageChanged, onPageChanged = _a === void 0 ? function (f) { return f; } : _a;
            var currentPage = Math.max(0, Math.min(page, _this.getTotalPages()));
            var paginationData = {
                currentPage: currentPage,
                totalPages: _this.getTotalPages(),
                pageLimit: _this.getPageLimit(),
                totalRecords: _this.getTotalsRecord()
            };
            var result = {
                paginationData: paginationData,
                pageLimit: _this.form.$.pageLimit.value
            };
            _this.setState({ currentPage: currentPage }, function () { return onPageChanged(result); });
        };
        _this.handleClick = function (page, evt) {
            evt.preventDefault();
            _this.gotoPage(page);
        };
        _this.handleMoveLeft = function (evt) {
            evt.preventDefault();
            _this.gotoPage(_this.state.currentPage - _this.getPageNeighbours() * 2 - 1);
        };
        _this.handleMoveRight = function (evt) {
            evt.preventDefault();
            _this.gotoPage(_this.state.currentPage + _this.getPageNeighbours() * 2 + 1);
        };
        _this.fetchPageNumbers = function () {
            var totalPages = _this.getTotalPages();
            var currentPage = _this.state.currentPage;
            var pageNeighbours = _this.getPageNeighbours();
            var totalNumbers = _this.getPageNeighbours() * 2 + 3;
            var totalBlocks = totalNumbers + 2;
            if (totalPages > totalBlocks) {
                var pages = void 0;
                var leftBound = currentPage - pageNeighbours;
                var rightBound = currentPage + pageNeighbours;
                var beforeLastPage = totalPages - 1;
                var startPage = leftBound > 2 ? leftBound : 2;
                var endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
                pages = range(startPage, endPage);
                var pagesCount = pages.length;
                var singleSpillOffset = totalNumbers - pagesCount - 1;
                var leftSpill = startPage > 2;
                var rightSpill = endPage < beforeLastPage;
                var leftSpillPage = types_1.LEFT_PAGE;
                var rightSpillPage = types_1.RIGHT_PAGE;
                if (leftSpill && !rightSpill) {
                    var extraPages = range(startPage - singleSpillOffset, startPage - 1);
                    pages = __spreadArray(__spreadArray([leftSpillPage], extraPages, true), pages, true);
                }
                else if (!leftSpill && rightSpill) {
                    var extraPages = range(endPage + 1, endPage + singleSpillOffset);
                    pages = __spreadArray(__spreadArray(__spreadArray([], pages, true), extraPages, true), [rightSpillPage], false);
                }
                else if (leftSpill && rightSpill) {
                    pages = __spreadArray(__spreadArray([leftSpillPage], pages, true), [rightSpillPage], false);
                }
                return __spreadArray(__spreadArray([1], pages, true), [totalPages], false);
            }
            return range(1, totalPages);
        };
        _this.getBackgroundColorCurrentPage = function () {
            return _this.props.customerStyle &&
                _this.props.customerStyle.pageSelectedBackgroundColor
                ? _this.props.customerStyle.pageSelectedBackgroundColor
                : '#e8e8e8';
        };
        _this.getColorCurrentPage = function () {
            return _this.props.customerStyle &&
                _this.props.customerStyle.pageSelectedColor
                ? _this.props.customerStyle.pageSelectedColor
                : 'black';
        };
        _this.getBackgroundHover = function () {
            return _this.props.customerStyle &&
                _this.props.customerStyle.pageHoverBackgroundColor
                ? _this.props.customerStyle.pageHoverBackgroundColor
                : '#e8e8e8';
        };
        _this.getColorHover = function () {
            return _this.props.customerStyle && _this.props.customerStyle.pageHoverColor
                ? _this.props.customerStyle.pageHoverColor
                : 'black';
        };
        _this.getBorderRadius = function () {
            return _this.props.customerStyle
                ? _this.props.customerStyle.borderRadius
                    ? _this.props.customerStyle.borderRadius
                    : '8px'
                : '8px';
        };
        _this.getStyles = function () {
            return __assign({ display: 'flex', alignItems: 'center', border: 'solid 1px whitesmoke', borderRadius: _this.getBorderRadius(), width: 'fit-content' }, _this.props.style);
        };
        _this.onItemsByPageChange = function (value) {
            _this.form.$.pageLimit.onChange(value);
            _this.gotoPage(1);
            if (_this.props.onPageSizeChanged) {
                _this.props.onPageSizeChanged(value);
            }
        };
        _this.getColorIcon = function () {
            return _this.props.customerStyle && _this.props.customerStyle.iconColor
                ? _this.props.customerStyle.iconColor
                : 'black';
        };
        _this.form = new formstate_1.FormState({
            pageLimit: new formstate_1.FieldState(_this.getPageLimit())
        });
        _this.state = { currentPage: 1 };
        return _this;
    }
    VPagination.prototype.componentDidMount = function () {
        this.gotoPage(this.props.currentPage);
    };
    VPagination.prototype.render = function () {
        var _this = this;
        if (!this.getTotalsRecord())
            return null;
        var currentPage = this.state.currentPage;
        var pages = this.fetchPageNumbers();
        return (react_1.default.createElement("div", { style: this.getStyles() },
            this.props.hideItemsByPage !== true && this.renderItemsByPages(),
            this.props.hideInfoLabels !== true && this.renderInfoPage(currentPage),
            react_1.default.createElement("div", null,
                react_1.default.createElement(style_1.Pages, { className: "pagination" }, pages.map(function (page, index) {
                    if (page === types_1.LEFT_PAGE) {
                        return _this.getLeftPage(index);
                    }
                    if (page === types_1.RIGHT_PAGE) {
                        return _this.getRightPage(index);
                    }
                    return (react_1.default.createElement(style_1.Page, { key: index, backgroundColor: currentPage === page
                            ? _this.getBackgroundColorCurrentPage()
                            : 'transparent', color: _this.getColorCurrentPage(), backgroundHover: currentPage === page
                            ? _this.getBackgroundColorCurrentPage()
                            : _this.getBackgroundHover(), colorHover: _this.getColorHover(), onClick: function (e) {
                            _this.handleClick(page, e);
                        }, isLast: index + 1 === pages.length, border: _this.getBorderRadius() }, page));
                })))));
    };
    VPagination.prototype.renderInfoPage = function (currentPage) {
        if (this.props.labels && this.props.labels.renderInfoDetails) {
            return this.props.labels.renderInfoDetails({
                currentPage: currentPage,
                totalPages: this.getTotalPages(),
                totals: this.getTotalsRecord()
            });
        }
        return (react_1.default.createElement(InfoPage, { currentPage: currentPage, totalPages: this.getTotalPages(), totals: this.getTotalsRecord(), pageLabel: this.props.labels ? this.props.labels.pages : undefined, ofLabel: this.props.labels ? this.props.labels.of : undefined, totalLabel: this.props.labels ? this.props.labels.total : undefined }));
    };
    VPagination.prototype.renderItemsByPages = function () {
        var label = this.props.labels && this.props.labels.itemsByPage;
        return (react_1.default.createElement(ItemsByPages, { fieldState: this.form.$.pageLimit, options: this.getItemsByPages(), label: label, onChange: this.onItemsByPageChange, color: this.getColorCurrentPage() }));
    };
    VPagination.prototype.getRightPage = function (index) {
        var _this = this;
        return (react_1.default.createElement(style_1.Page, { onClick: function (e) {
                _this.handleMoveRight(e);
            }, key: index, className: "page-item" },
            react_1.default.createElement(core_1.Icon, { style: { color: this.getColorIcon() }, icon: 'chevron-right' })));
    };
    VPagination.prototype.getLeftPage = function (index) {
        var _this = this;
        return (react_1.default.createElement(style_1.Page, { onClick: function (e) {
                _this.handleMoveLeft(e);
            }, key: index, className: "page-item" },
            react_1.default.createElement(core_1.Icon, { style: { color: this.getColorIcon() }, icon: 'chevron-left' })));
    };
    return VPagination;
}(react_1.Component));
exports.VPagination = VPagination;
